export default __webpack_public_path__ + "static/media/settings.abfe39b1.jpg";